<template>
  <ul :class="$style.list">
    <li
      :class="$style.list__item"
      :key="article.id"
      v-for="article in articles"
    >
      <AdminNewsListItem
        :class="$style.list__content"
        :adminNewsListItem="article"
      />
    </li>
  </ul>
</template>

<script lang="ts" setup>
import type { AdminNewsListNewsForPlannerFragment } from './AdminNewsList.generated'
import AdminNewsListItem from './AdminNewsListItem.vue'

defineProps<{
  articles: AdminNewsListNewsForPlannerFragment[]
}>()
</script>

<style lang="scss" module>
.list {
  display: block;
  padding: 0 32px;

  &__item {
    &:nth-child(n + 2) {
      border-top: solid 1px $color-border-low-emphasis;
    }
  }

  &__content {
    cursor: pointer;
  }
}
</style>
